import { $body, $window, $document } from '../utils/environment';
import Dropdown from './Dropdown';
import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.isActive = false;

        this.init();
    }

    /**
     * Initialisation.
     *
     * @return {void}
     */
    init() {
        // initialisation du dropdown
        this.dropdown = new Dropdown({
            $el: this.$el,
            'dropdown-mode': 'accordion',
            'dropdown-scrollto': true,
            'dropdown-scrolltoParent': this.$el
        });

        // initialisation des événements
        this.initEvents();
    }

    /**
     * Initialisation des événements.
     *
     * @return {void}
     */
    initEvents() {
        $document.on('toggle.HeaderNavigation', event => {
            this.toggle();
        });

        $document.on('close.HeaderNavigation', event => {
            this.close();
        });
    }

    /**
     * Gestion du toggle pour l'affichage du menu.
     *
     * @return {void}
     */
    toggle() {
        if (this.isActive) {
            this.dropdown.closeAllWithin();
            this.$el.animate({ scrollTop:0 }, '300', 'swing', () => {
                $body.removeClass('has-header-navigation-opened');
            });
        } else {
            $body.addClass('has-header-navigation-opened');
        }

        this.isActive = !this.isActive;
    }

    /**
     * Fermeture de l'affichage du menu.
     *
     * @return {void}
     */
    close() {
        this.dropdown.closeAllWithin();
        this.$el.animate({ scrollTop:0 }, '300', 'swing', () => {
            $body.removeClass('has-header-navigation-opened');
        });
        this.isActive = false;
    }

    /**
     * Déstructeur.
     *
     * @return {void}
     */
    destroy() {
        this.$el.off('.HeaderNavigation');
        $document.off('.HeaderNavigation');

        this.dropdown.destroy();

        this.isActive = false;
    }
}
